import { Heading, Level } from "react-bulma-components";
import BULMA_CONSTANTS from "react-bulma-components/lib/constants";

import { displayCurrency } from "../../utils";

const { BREAKPOINTS } = BULMA_CONSTANTS;
import {STAT_SIZE} from "../../constants";

const statsItemStyle = {
  textAlign: "center"
};

const JobStatsCard = ({ job }) => {
  const minSalary = job.minSalary
    ? displayCurrency(job.minSalary, job.salaryCurrency)
    : null;

  const maxSalary = job.maxSalary
    ? displayCurrency(job.maxSalary, job.salaryCurrency)
    : null;
  return (
    <Level renderAs="nav" breakpoint={BREAKPOINTS.MOBILE} className="is-mobile">
      <Level.Item style={statsItemStyle}>
        <div>
          <Heading renderAs="p" heading>
            Bounty
          </Heading>
          <Heading renderAs="p" size={STAT_SIZE}>
            {displayCurrency(job.bounty, job.bountyCurrency)}
          </Heading>
        </div>
      </Level.Item>
      {job.showSalary && (
        <Level.Item>
          <div>
            <Heading renderAs="p" heading>
              Min. Salary
            </Heading>
            <Heading renderAs="p" size={STAT_SIZE}>
              {job.maxSalary > job.minSalary ? `${minSalary}` : minSalary}{" "}
              <small>{job.payUnit && `/ ${job.payUnit.toLowerCase()}`}</small>
            </Heading>
          </div>
        </Level.Item>
      )}
      {/* <Level.Item style={statsItemStyle}>
      <div>
        <Heading renderAs="p" heading>
          Candidates
        </Heading>
        <Heading renderAs="p" size={STAT_SIZE}>
          {job.submissionCount}
        </Heading>
      </div>
    </Level.Item> */}
    </Level>
  );
};

// export default createFragmentContainer(JobStatsCard, {
//   job: graphql`
//     fragment JobStatsCard_job on JobNode {
//       bounty
//       bountyCurrency
//       submissionCount
//     }
//   `
// });

export default JobStatsCard;
